<template>
	<div class="filters">
		<div class="wrap">
			<div class="search">
				<div class="label" @click="open = !open">
					Filtrer
					<div class="arrow" :class="{open}" v-html="require('@/assets/icons/sort-down-solid.svg')" />
				</div>
				<search @update="update"/>
			</div>
			<div class="expand" :class="{open}">
				<type v-bind="{endpoint: 'client/product-types', name: 'product', title: 'Produkttype', activeType}" @update="update" @activeType="toggleType"/>
				<type v-bind="{endpoint: 'client/content-types', name: 'content', title: 'Indholdstype', activeType}" @update="update" @activeType="toggleType"/>
			</div>
		</div>
	</div>
</template>

<script>
import search from "./search.vue";
import type from "./type.vue";

export default {
	components: {search, type},
	data() {
		return {
			activeType: "",
			open: false
		}
	},
	computed: {
		query: (t) => t.$route.query
	},
	methods: {
		update(query) {
			this.$router.replace({query: {...this.query, ...query}});
			this.$emit("update");
		},
		toggleType(type) {
			this.activeType = this.activeType === type ? '' : type;
		}
	}
};
</script>

<style lang="scss" scoped>
.filters {
	position: fixed;
	left: 0;
	top: $header;
	background-color: #22313A;
	color: $white1;
	width: $libFilters;
	height: 100vh;

	@include res(mobile) {
		position: relative;
		width: 100%;
		top: 0;
		height: auto;
	}

	.search {
		.label {
			display: none;
			@include res(mobile) {
				display: inline-flex;
				align-items: center;
			}
			.arrow {
				margin-left: 7px;
				position: relative;
				top: -3px;
				&.open {
					transform: scaleY(-1);
					transform-origin: center center;
					top: -1px;
				}
				/deep/ svg {
					width: 18px;
					height: 18px;
				}
			}
		}
		@include res(mobile) {
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-direction: row-reverse;
		}
	}

	.expand {
		@include res(mobile) {
			display: none;
			&.open {
				display: block;
			}
		}
	}

	.wrap {
		padding: 40px;

		@include res(mobile) {
			padding: 25px;
		}
	}
}
</style>
